
  import { Committee } from '@/services/api/models'
  import { defineComponent, watch } from 'vue'
  import moment from 'moment'
  export default defineComponent({
    name: 'CommitteeCard',
    props: {
      event: {
        type: Object as () => Committee | undefined,
        required: true
      }
    },
    setup(props) {
      watch(
        () => props.event,
        (val) => {
          console.log(val, 'props.event')
        }
      )
      return { moment }
    }
  })
